import { render, staticRenderFns } from "./reset_password.html?vue&type=template&id=042c78c3&scoped=true&"
import script from "./reset_password.js?vue&type=script&lang=js&"
export * from "./reset_password.js?vue&type=script&lang=js&"
import style0 from "./reset_password.scss?vue&type=style&index=0&id=042c78c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c78c3",
  null
  
)

export default component.exports